import "./profile.css";
import Heading from "../../heading/Heading";

const Profile = () => {
  return (
    <div className="profile d-flex flex-column justify-content-center align-items-md-start align-items-sm-center align-items-center">
      <div className="profile-video">
        <video autoPlay loop muted>
          <source src="/assets/videos/video-1.mp4" type="video/mp4" />
        </video>
        <div className="background-overlay"></div>
      </div>
      <div className="profile-details d-flex flex-column">
        <Heading word="Hi, I'm Nika, Web developer" headingSize="h1" />
        <p>React Developer</p>
      </div>
      <div className="profile-buttons">
        <a
          href="https://drive.google.com/file/d/1IkdErYFw5VUe6a7XIcdpU_c1HFmMXx6F/view?usp=drive_link"
          className="resume-btn button"
          rel="noreferrer"
          target="_blank"
        >
          View My Resume
        </a>
      </div>
    </div>
  );
};

export default Profile;
